import { connect } from "react-redux";
import SchedulePreferences from './schedule_preferences';

const mSTP = (state, ownProps) => {
  return {
    config: state.config,
    appointments: state.appointments
  };
};

const mDTP = dispatch => ({
});

export default connect(mSTP, mDTP)(SchedulePreferences);
